import axios from "axios";

export const client = axios.create({
  //
   //baseURL:"http://154.56.46.6:8080/marisoft-dev/marisoft/"
  // baseURL: "http://localhost:18888/marisoft/", //process.env.REACT_APP_API_KEY
baseURL:"/marisoft-dev/marisoft/"
});
